import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <header className="bg-gray-800 text-white p-4">
      <div className="container mx-auto flex justify-between items-center">
        <Link to="/" className="text-xl font-bold">Shahji Computers ERP</Link>
        <nav>
          <Link to="/login" className="px-3">Login</Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
